/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import MessageBox from '@/components/shared/MessageBox'
import OsVersionService from '@/services/OsVersionService'
import {OsVersionVO} from '@/valueObjects/OsVersionVO'
import OsVersionServiceMixin from '@/services/OsVersionServiceMixin'
import Multiselect from 'vue-multiselect'
import {Getter, Mutation} from 'vuex-class'
import {DEFAULT_OSVERSION, DEFAULT_VISIBILITY, VISIBILITY_LIST} from '@/utils/constants'
import {UserVO} from '@/valueObjects/UserVO'
import {UserService} from '@/services/UserService'
import UserServiceMixin from '@/services/UserServiceMixin'
@Component({
    mixins: [OsVersionServiceMixin, UserServiceMixin],
    components: {
        MessageBox,
        Multiselect,
    },
})
export default class Preferences extends Vue {
    @Getter('getCurrentUser') private currentUser: UserVO
    @Mutation('setCurrentUser') private setCurrentUser: any
    private message: string = ''
    private messageType = 'danger'
    private isVirusTotalSelected: boolean = false
    private isPfavSelected: boolean = false
    private isGUIInteractionSelected: boolean = false
    private isDynamicAnalysisSelected: boolean = false
    private isInternetSelected: boolean = true

    private osList: OsVersionVO[] = []
    private osVersionService: OsVersionService
    private selectedOs = new OsVersionVO(DEFAULT_OSVERSION.description, DEFAULT_OSVERSION.osVersion)

    private selectedVisibility: string = DEFAULT_VISIBILITY
    private visibilityList: string[] = VISIBILITY_LIST
    private userService: UserService // redeclared variable to avoid warnings in Webstorm

    public async mounted(): Promise<void> {
        try {
            this.osList = await this.osVersionService.getOsVersions()
            this.isVirusTotalSelected = this.currentUser.virusTotalSelected
            this.isPfavSelected = this.currentUser.pfavSelected
            this.isGUIInteractionSelected = this.currentUser.isGuiInteractive
            this.isDynamicAnalysisSelected = this.currentUser.DynamicAnalysisSelected
            this.selectedVisibility = this.currentUser.visibility ? this.currentUser.visibility : DEFAULT_VISIBILITY
            this.selectedOs = this.currentUser.osVersion
            this.isInternetSelected = this.currentUser.InternetSelected
            this.message = ''
        } catch (e) {
            this.message = `The loading of available Os versions failed. ${e.errorMessage}`
        }
    }
    public async save(): Promise<void> {
        try {
            const user = new UserVO()
            user.id = this.currentUser.id
            user.email = this.currentUser.email
            user.roles = this.currentUser.roles
            user.failedAttempts = this.currentUser.failedAttempts
            user.firstName = this.currentUser.firstName
            user.lastName = this.currentUser.lastName
            user.failedAttempts = this.currentUser.failedAttempts
            user.osVersion = this.selectedOs
            user.virusTotalSelected = this.isVirusTotalSelected
            user.pfavSelected = this.isPfavSelected
            user.visibility = this.selectedVisibility
            user.isGuiInteractive = this.isGUIInteractionSelected
            user.DynamicAnalysisSelected = this.isDynamicAnalysisSelected
            user.InternetSelected = this.isInternetSelected
            await this.userService.save_pref(user)
            this.setCurrentUser(user)
            this.messageType = 'success'
            this.message = 'Preferences saved'
        } catch (e) {
            this.messageType = 'danger'
            this.message = `The modification of preferences failed. ${e.errorMessage}`
        }
    }

    private clearMessage() {
        this.message = ''
    }
}
